module.exports = __webpack_public_path__ + "img/72.832b8d85.jpg";